import styled from 'styled-components';

export const MyInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  .myinfoTitle {
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    align-items: center;
  }

  .myInfoContentBox {
    border: 1px solid var(--GrayScale-200);
    background: var(--GrayScale-0);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 10px;
  }

  .termsAndPolicyBox {
    border: 1px solid var(--GrayScale-200);
    background: var(--GrayScale-0);
    padding: 16px;
    border-radius: 10px;
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  .myInfoTitleIcon {
    width: 24px;
    height: 24px;
    padding: 2px;
    border-radius: 5px;
    background: var(--Primary-50);
  }

  // 주소
  .itemTitle {
    background: var(--GrayScale-600);
    color: var(--GrayScale-0);
    padding: 0px 10px;
  }

  .addressItem {
    padding: 10px 8px;
    // align-items: center;
    border-bottom: 1px solid var(--GrayScale-400);
  }
`;
